import {sum, values} from 'lodash/fp'
import React, {Component} from 'react'

import Button from '../../components/Button'
import Checkout from '../../components/Checkout'

import {YearPreamble, HouseholdPreamble, Crowdrise, WhereGoes} from './preambles'
import './styles.css'

const PER_TONNE = 25

class Payment extends Component {
  render() {
    const {country, onSingleFiling, emissions, multiplier} = this.props
    const usa = country === 'US'

    const co2 = usa ? sum(values(emissions)) : 0
    const cost = co2 * PER_TONNE * parseInt(multiplier, 10)
    const monthly = (cost / 12)
    const annual = (cost * .85)
    
    return (
      <div className="payment">
        <Checkout
          preamble={<HouseholdPreamble multiplier={multiplier} />}
          label="Joint Monthly Amount"
          amount={monthly.toFixed(2)}
          caption={Crowdrise}
          co2={co2}
          type='joint_monthly'
          monthly={true}
        />
        <Checkout
          preamble={YearPreamble}
          label="One-time Annual Amount"
          amount={annual.toFixed(2)}
          caption="15% Credit"
          co2={co2}
          type='joint_annual'
        />
        <WhereGoes />
        <div className="payment-buffered payment-explanation">
          <div className="payment-explanation-header">File Individually</div>
          <div className="payment-explanation-text">
            If you would like to offset only your own
            personal climate impact, click below.
          </div>
          <Button className="payment-btn" onClick={onSingleFiling}>Individual Offset</Button>
        </div>
      </div>
    )
  }
}

export default Payment



// WEBPACK FOOTER //
// ./src/apps/Payment/Joint.js